import React, { useEffect, useState, Fragment, useContext, useInsertionEffect } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import TableSection from 'components/sales/tableSection/tableSection';
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import DivLayout from "components/sales/divLayout/divLayout";
import FormSection from "components/sales/formSection/formSectionNew";
import ProductInventory from "components/sales/formSection/productInventoryOps/productInventory";

const InventoryChecklist = ({
  match,
  location,
  inventoryData,
  getInventory,
  getMaterial,
  getMateriaById,
  postGateInventory,
  getGateInfo,
  getGateDetail,
  gateDetail,
  getBrand,
  getBrandById,
  gateInfo,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setlistData] = useState();
  const [siteListData, setGateListData] = useState();
  const [isFiled, setIsFiled] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const todayDate = new Date().toISOString().slice(0, 10);
  const [inventoryForm, setInventoryForm] = useState({
    site_id: "",
    gate_id: "",
    data: [],
  });
  const [prefilledData,setPreFilledData] = useState([]);
  const headers = [
    'Material Name',
    'Quantity',
    
  ];
  useEffect(() => {
    if (getInventory !== null)
      (async () => await getInventory(location.state.url))();
  }, [getInventory]);

  useEffect(() => {
    if (getGateInfo !== null && match.params.id && location.state.gateId)
      (async () => {
        setIsLoading(true);
        await getGateInfo(match.params.id, location.state.gateId);
        setIsLoading(false);
      })();
  }, [getGateInfo, match.params.id]);

  useEffect(() => {
    if (getGateDetail !== null && match.params.id && location.state.gateId)
      (async () => {
        setIsLoading(true);
        await getGateDetail(match.params.id, location.state.gateId);
        setIsLoading(false);
      })();
  }, [getGateDetail, match.params.id]);

  useEffect(() =>{
    if(gateDetail && gateDetail.material){
      setPreFilledData(gateDetail.material);
    }
    
  },[gateDetail]);

  useEffect(() => {
    if (inventoryData) {
      setlistData(inventoryData);
    }
  }, [inventoryData]);

  // useEffect(() => {
  //   if (gateDetail) {
  //     setGateListData(gateDetail);
  //   }
  // }, [gateDetail]);

  const handleProductData = (val) => {
    setInventoryForm({
      ...inventoryForm,
      data: val.productData,
      matReq: val.materialRequired,
      site_id: match.params.id,
      gate_id: location.state.gateId,
      stage_checklist_id: location.state.checklistId,
    });
  };
  const handleSubmit = () => {
    setIsClicked(true);
    if(inventoryForm.matReq === 'No'){
      setIsFiled(true);
      (async () => {
        const res = await postGateInventory(inventoryForm);
        if (res === true) {
          setIsModal(true);
        }
      })();
    }
    else if (
      inventoryForm.data === null ||
      inventoryForm?.data.length <= 0 ||
      inventoryForm.data[0].category_id === "" ||
      inventoryForm.data[0].material_id === "" ||
      inventoryForm.data[0].quantity === "" 
    ) {
      console.log(inventoryForm);
      setIsClicked(false);
      setIsFiled(true);
      setIsModal(false);
    } else {
      setIsFiled(true);
      (async () => {
        // console.log(inventoryForm); return false;
        const res = await postGateInventory(inventoryForm);
        if (res === true) {
          setIsModal(true);
        }
      })();
    }
  };
  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/gate/site-inspection/${match.params.id}/stage/1`);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary" disabled={isClicked}>
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  useEffect(() => {
  const tableData = [
    'name',
    'quantity', 
  ];
}, [gateDetail]);

  return (
    <Layout
      title={localization.inventoryChecklist}
      className={isFiled ? "requiredFileds" : ""}
      Buttons={headerBtns}
      isGoback
      linkFlag={true}
      linkUrl={`${baseUrl}/site_inspection_material/${match.params.id}/stage/${match.params.stageId}`}
      // linkUrl={`${baseUrl}/gate/site-inspection/${match.params.id}/stage/${match.params.stageId}`}
      isLoading={isLoading}
    >
      
      <div>
      
      <FormSection title={gateInfo && gateInfo.gates && localization.solution + ' - '+  gateInfo.gates[0].gate_no}>
        <div className="details-listing">
          <DivLayout
            heading={localization.siteNumber}
            gate_no
            data={gateInfo && gateInfo.sites && gateInfo.sites.site_no}
          />
          <DivLayout
            heading={localization.solution}
            data={gateInfo && gateInfo.gates && gateInfo.gates[0].gateName}
          />
          {/* <DivLayout
            heading={localization.gateType}
            data={gateInfo && gateInfo.gates && gateInfo.gates[0].used_for}
          /> */}
          {/* <DivLayout
            heading={localization.currentDate}
            data={todayDate && todayDate}
          /> */}
        </div>
      </FormSection>
      <FormSection title={localization.materialAddedBySale}>
          <>
          {gateDetail && gateDetail.category && 
            <table style={{border:'1px solid',width : '100%'}}>
              <tr style={{border:'1px solid',backgroundColor:'#2f80ed',color:'#fff'}}>
                <th style={{border:'1px solid',padding:'6px'}}>Category</th>
                <th style={{border:'1px solid',padding:'6px'}}>Ops Qty</th>
                <th style={{border:'1px solid',padding:'6px'}}>Sales Qty</th>
              </tr>
              {gateDetail && gateDetail.category.map((obj, index) => {
                return(
                <>
                {obj.operation_quantity === obj.sale_quantity ? 
                  <tr key={index}>
                    <td style={{border:'1px solid',padding:'6px'}}>{obj.name}</td>
                      <td style={{border:'1px solid',padding:'6px'}}>{obj.operation_quantity}</td>
                      <td style={{border:'1px solid',padding:'6px'}}>{obj.quantity}</td>
                    </tr>
                  :
                  <tr key={index} style={{"backgroundColor":"#ffe6e6"}}>
                    <td style={{border:'1px solid',padding:'6px'}}>{obj.name}</td>
                      <td style={{border:'1px solid',padding:'6px'}}>{obj.operation_quantity}</td>
                      <td style={{border:'1px solid',padding:'6px'}}>{obj.quantity}</td>
                   </tr>
                  }
                  </>
                );
               
              })}
            
            </table>
            }
            {/* <TableSection
              data={gateDetail}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}   
              srNo={siteListData?.from}
            /> */}
          </>
     
      </FormSection>
      <FormSection title={localization.materialAddedBySale}>
            
          <>
          <div className="row">
            <div className="col-12" style={{color:"green"}}> ➤ Brand</div>
            <div className="col-12" style={{color:"blue"}}> ➤ Specification</div>
          </div>
          {gateDetail && gateDetail.saleHardwaresData && 
            <table style={{border:'1px solid',width : '100%'}}>
              <tr style={{border:'1px solid',backgroundColor:'#2f80ed',color:'#fff'}}>
                <th style={{border:'1px solid',padding:'6px'}}>Category</th>
                <th style={{border:'1px solid',padding:'6px'}}>material Detail</th>
                <th style={{border:'1px solid',padding:'6px'}}>Sales Qty</th>
              </tr>
              {gateDetail && gateDetail.saleHardwaresData.map((obj, index) => {
                return(
                  <tr key={index}>
                    <td style={{border:'1px solid',padding:'6px'}}>{obj.category_name}</td>
                      <td style={{border:'1px solid',padding:'6px'}}><strong style={{color:"green"}}>{obj.brand_name}</strong> <br/> {obj.material_name} <br/>
                      <strong style={{color:"blue"}}>{obj.specification}</strong></td>
                      <td style={{border:'1px solid',padding:'6px'}}>{obj.quantity}</td>
                    </tr>
                 
                );
               
              })}
            
            </table>
            }
           
          </>
     
      </FormSection>
      </div>
      {console.log(prefilledData)}
      <ProductInventory
        data={inventoryData}
        getMaterial={getMaterial}
        getMateriaById={getMateriaById}
        getBrandById={getBrandById}
        getBrand={getBrand}
        handleValue={handleProductData}
        prefilledData={prefilledData}
      />
      
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/site_inspection_material/${match.params.id}/stage/1`}
            className="btn btn-primary mb-4"
          >
            {localization.viewSiteInformation}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default InventoryChecklist;
